var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 67,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 151 67)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6011 24.509C62.0505 24.6737 62.0504 25.326 61.601 25.4905C55.7256 27.6413 53.6409 29.7253 51.4905 35.6008C51.326 36.0502 50.6736 36.0504 50.5089 35.601C48.3568 29.7277 46.2739 27.6438 40.3989 25.491C39.9495 25.3263 39.9496 24.674 40.399 24.5095C46.2744 22.3587 48.3592 20.2747 50.5095 14.3992C50.674 13.9498 51.3264 13.9496 51.4911 14.399C53.6432 20.2723 55.7261 22.3562 61.6011 24.509Z",
    fill: "url(#paint0_linear_1_32913)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 31.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 142.5 31.5)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5703 52.7131V48.9988C70.5703 34.6393 82.2109 22.9988 96.5703 22.9988C110.93 22.9988 122.57 34.6393 122.57 48.9988V52.7131",
    stroke: "url(#paint1_linear_1_32913)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.57 82.4274V52.7131H133.713C137.816 52.7131 141.142 56.0391 141.142 60.1417V74.9989C141.142 79.1015 137.816 82.4274 133.713 82.4274H122.57Z",
    stroke: "url(#paint2_linear_1_32913)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.573 82.4272V89.8558C122.573 96.7785 117.838 102.596 111.43 104.245",
    stroke: "url(#paint3_linear_1_32913)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.997 112.142H89.1395C85.0369 112.142 81.7109 108.816 81.7109 104.713C81.7109 100.61 85.0369 97.2844 89.1395 97.2844H103.997C108.099 97.2844 111.425 100.61 111.425 104.713C111.425 108.816 108.099 112.142 103.997 112.142Z",
    stroke: "url(#paint4_linear_1_32913)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 74.9989V60.1417C52 56.0391 55.3259 52.7131 59.4286 52.7131H70.5714V82.4274H59.4286C55.3259 82.4274 52 79.1015 52 74.9989Z",
    stroke: "url(#paint5_linear_1_32913)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_32913",
    x1: 36.4265,
    y1: 39.28,
    x2: 67.8191,
    y2: 37.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_32913",
    x1: 64.9944,
    y1: 55.5359,
    x2: 132.556,
    y2: 48.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_32913",
    x1: 120.579,
    y1: 85.2503,
    x2: 144.919,
    y2: 84.3792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_32913",
    x1: 110.235,
    y1: 106.318,
    x2: 124.845,
    y2: 105.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_32913",
    x1: 78.5247,
    y1: 113.553,
    x2: 117.014,
    y2: 109.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_32913",
    x1: 50.0086,
    y1: 85.2503,
    x2: 74.349,
    y2: 84.3792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.80977ce1c69c632a3acf43fbceefeb4c.svg";
export { ForwardRef as ReactComponent };